/**
 * 钉钉通讯录本地目录：部门/人员映射，供各页展示与 Drawer 复用
 */

let depsList = [];
let usersList = [];
let depMap = Object.create(null);
let userMap = Object.create(null);
let loaded = false;
let loading = null;

function unwrap(res) {
  return (res && res.data && res.data.data) || (res && res.data) || {};
}

function rebuildMaps() {
  depMap = Object.create(null);
  depsList.forEach((d) => {
    if (d && d.id != null) depMap[String(d.id)] = d;
  });
  // 虚拟根
  if (!depMap['1']) {
    depMap['1'] = {id: 1, name: '根部门', parent_id: null};
  }
  userMap = Object.create(null);
  usersList.forEach((u) => {
    if (u && u.userid) userMap[String(u.userid)] = u;
  });
}

export async function ensureDingDirectory(api, options) {
  const forced = !!(options && (options.forced || options.force));
  if (!forced && loaded) {
    return {deps: depsList, users: usersList, depMap, userMap};
  }
  if (loading && !forced) return loading;

  loading = Promise.all([
    api.get(forced ? '/ding/deps?forced=1' : '/ding/deps'),
    api.get(forced ? '/ding/users?forced=1' : '/ding/users'),
  ]).then(([depsRes, usersRes]) => {
    const depsData = unwrap(depsRes);
    const usersData = unwrap(usersRes);
    depsList = Array.isArray(depsData.list) ? depsData.list : [];
    usersList = Array.isArray(usersData.list) ? usersData.list : [];
    rebuildMaps();
    loaded = true;
    return {deps: depsList, users: usersList, depMap, userMap};
  }).finally(() => {
    loading = null;
  });

  return loading;
}

export function getDepMap() {
  return depMap;
}

export function getUserMap() {
  return userMap;
}

export function getDepsList() {
  return depsList;
}

export function getUsersList() {
  return usersList;
}

export function getDeptName(id) {
  if (id == null || id === '') return '';
  const d = depMap[String(id)];
  return (d && d.name) || String(id);
}

export function getDept(id) {
  if (id == null || id === '') return null;
  return depMap[String(id)] || null;
}

export function formatDeptNames(list) {
  if (!list) return '-';
  const arr = Array.isArray(list) ? list : String(list).split(',');
  if (!arr.length) return '-';
  return arr.map((id) => getDeptName(id)).filter(Boolean).join('、') || '-';
}

export function getUserName(userid) {
  if (!userid) return '';
  const u = userMap[String(userid)];
  return (u && u.name) || String(userid);
}

export function getUser(userid) {
  if (!userid) return null;
  return userMap[String(userid)] || null;
}

export function formatUserLabel(userid) {
  if (!userid) return '-';
  const u = getUser(userid);
  if (!u) return String(userid);
  return u.name ? `${u.name}（${userid}）` : String(userid);
}

/** 从流程表单值里解析可点击的人员 / 部门引用 */
export function resolveDirectoryRefs(value) {
  const users = [];
  const depts = [];
  const seenU = new Set();
  const seenD = new Set();

  const pushUser = (id) => {
    const key = String(id || '').trim();
    if (!key || seenU.has(key) || !getUser(key)) return;
    seenU.add(key);
    users.push(key);
  };
  const pushDept = (id) => {
    const key = String(id || '').trim();
    if (!key || seenD.has(key)) return;
    if (!getDept(key) && !/^\d+$/.test(key)) return;
    seenD.add(key);
    depts.push(key);
  };

  const walk = (v, depth = 0) => {
    if (v == null || depth > 4) return;
    if (typeof v === 'string' || typeof v === 'number') {
      const s = String(v).trim();
      if (!s) return;
      if (getUser(s)) {
        pushUser(s);
        return;
      }
      if (s.includes(',')) {
        s.split(',').forEach((part) => walk(part.trim(), depth + 1));
        return;
      }
      if (/^\d+$/.test(s)) pushDept(s);
      return;
    }
    if (Array.isArray(v)) {
      v.forEach((item) => walk(item, depth + 1));
      return;
    }
    if (typeof v === 'object') {
      if (v.userid) pushUser(v.userid);
      if (v.userId) pushUser(v.userId);
      if (v.originatorUserId) pushUser(v.originatorUserId);
      if (v.dept_id != null) pushDept(v.dept_id);
      if (v.deptId != null) pushDept(v.deptId);
      if (v.id != null && (v.name || v.parent_id != null) && /^\d+$/.test(String(v.id))) {
        pushDept(v.id);
      }
      Object.keys(v).forEach((k) => {
        if (['userid', 'userId', 'originatorUserId', 'dept_id', 'deptId', 'id', 'name', 'parent_id'].includes(k)) return;
        walk(v[k], depth + 1);
      });
    }
  };

  walk(value);
  return {users, depts};
}
